import React from "react";
import ReactDOM from "react-dom/client";

import { setupIonicReact } from "@ionic/react";

import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

import "./index.css";

import App from "./App.jsx";

// Required when not wrapping the app in <IonApp>. Registers Ionic's custom
// elements (ion-modal, ion-icon, ion-content, ion-page, ion-refresher, etc.)
// and sets the mode (iOS on iOS, Material elsewhere). Must run once before
// any Ionic component renders.
setupIonicReact();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);